import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class GenKisiService {
   public isShowInfo = false;
   public exBirlesenEh = false;
   public exIhaleKod: number;
   public teklifKod: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public customQuery:string;

   public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
   public gridControlsList$ = this._gridControlsList.asObservable();
    constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}

    getData(control:any,filterColumn:string,code:any, isShowInfo: boolean,exBirlesenEh:boolean,columnName:string, baseEntity?: string,filterArrParam?:any[], isSetData?: boolean) {

        const { dataSource, filterArr } = this.buildDataSource(control, baseEntity, exBirlesenEh, filterArrParam);

        filterArr.push([columnName, '=', code]);
        dataSource.filter(filterArr);
        return dataSource;
    }

    /**
     * Kişi Kod ile bulunamadığında devreye giren arama: aynı değeri TCKN veya Vergi No
     * olarak arar. Değer string olarak gönderilir - Number()'a çevrilirse Vergi No'nun
     * baştaki sıfırı kaybolur.
     */
    getDataByTcknVergiNo(control:any, code:any, exBirlesenEh:boolean, baseEntity?: string, filterArrParam?:any[]) {

        const { dataSource, filterArr } = this.buildDataSource(control, baseEntity, exBirlesenEh, filterArrParam);

        filterArr.push(this.tcknVergiNoFilter(code));
        dataSource.filter(filterArr);
        return dataSource;
    }

    /** DevExtreme filtre ifadesi: Tckn = code or VergiNo = code */
    tcknVergiNoFilter(code:any) {
        const value = String(code);
        return [['Tckn', '=', value], 'or', ['VergiNo', '=', value]];
    }

    private buildDataSource(control:any, baseEntity:string, exBirlesenEh:boolean, filterArrParam?:any[]) {

        let queryString = "?";
        let dataSource: any;
        let tableName = "";
        const filterArr = [];
        if (this.isBindCheck && this.isReadOnly){
            tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
            dataSource = this.dataCoreService.getOData(tableName);
        }
        else{
            if(exBirlesenEh){
                if(queryString.length === 1) queryString = queryString + "ExBirlesenEh=E";
                else if (queryString.length > 1) queryString = queryString + "&ExBirlesenEh=E";
            }
            if(this.exIhaleKod){
                if(queryString.length === 1) queryString = queryString + "ExIhaleKod=" + this.exIhaleKod;
                else if (queryString.length > 1) queryString = queryString + "&ExIhaleKod=" + this.exIhaleKod;
            }
            if(this.teklifKod){
                if(queryString.length === 1) queryString = queryString + "TeklifKod=" + this.teklifKod;
                else if (queryString.length > 1) queryString = queryString + "&TeklifKod=" + this.teklifKod;
            }

            if(this.customQuery){
                if (queryString?.length === 1) queryString = queryString + this.customQuery;
                else if (queryString?.length > 1) queryString = queryString + '&' + this.customQuery;
            }


                baseEntity = baseEntity + queryString;

            dataSource = this.dataCoreService.getOData(baseEntity,['GenKisiAdres','GenKisiIletisims']);
            if(filterArrParam?.length > 0) { filterArr.push(filterArrParam);}
        }

        return { dataSource, filterArr };
    }

    setParams(isShowInfo:boolean,exBirlesenEh: boolean,exIhaleKod: number,teklifKod: number, isReadOnly:boolean, isBindCheck:boolean,customQuery:string){
        this.isShowInfo = isShowInfo;
        this.exBirlesenEh = exBirlesenEh;
        this.exIhaleKod = exIhaleKod;
        this.teklifKod = teklifKod;
        this.isReadOnly = isReadOnly;
        this.isBindCheck = isBindCheck;
        this.customQuery = customQuery;
      }
}
